import loadable from "@loadable/component";
import SwitchTab from "../../../components/Reusable/SwitchTab";
import APIS from "../../../constant/Endpoint";
import useDeleteHook from "../../../customHooks/useDeleteHook";

const BankPaymentComponent = loadable(
  () => import("../../../components/Transaction/Bank/BankPayment/BankPayment")
);
const BankPayment = () => {
  const tabs = [
    {
      id: "bank-payment",
      label: "Bank Payment",
      href: "/accounting/bank-payment",
    },
    {
      id: "bank-receipt",
      label: "Bank Receipt",
      href: "/accounting/bank-receipt",
    },
  ];
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["bank-payment"],
  });

  const handleDelete = async (id: string, setOpenDeletePopup: any) => {
    const url = `${APIS.BILL}${id}/`;
    const formData = {};
    try {
      const res = await mutateAsync({ url, formData, setError: () => {} });
      if (res?.status === 204) {
        setOpenDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <SwitchTab tabs={tabs} />
      <BankPaymentComponent handleDelete={handleDelete} isLoading={isLoading} />
    </div>
  );
};

export default BankPayment;
